import * as React from "react";
import { withHubxType, legacy_withHubX } from "../../../HubX";
import { TEST_FEDX } from "../../../Fedx";
import { EVENT_TEST } from "../../../Events";
import { Card } from "@material-ui/core";

type LegacyDemoCState = { value: number; fedexTest?: string };
type LegacyDemoCProps = withHubxType;

class LegacyDemoC extends React.Component<LegacyDemoCProps, LegacyDemoCState> {
  constructor(props: LegacyDemoCProps) {
    super(props);
    this.state = {
      value: 0,
    };

    this.testFedex = this.testFedex.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.handleTestResponse = this.handleTestResponse.bind(this);

    props.attach(EVENT_TEST, this.updateValue, true);
  }

  componentDidMount() {
    this.testFedex();
  }

  updateValue(value: number) {
    this.setState({ value });
  }

  async testFedex() {
    const response = await this.props.request(TEST_FEDX);
    this.handleTestResponse(response);
  }

  handleTestResponse(APIResponse: string) {
    this.setState({ fedexTest: APIResponse });
  }

  render() {
    const { value, fedexTest } = this.state;

    return (
      <Card style={{ margin: 10, padding: 10, width: "50%" }}>
        <span>Componente Classe para teste de eventos do Hub Legado C.</span>

        <p>
          <span>Número aleatório de A: </span>
          <span>{value}</span>
        </p>

        {fedexTest && <p>Request pelo Fedex: {fedexTest}</p>}
      </Card>
    );
  }
}

export default legacy_withHubX(LegacyDemoC);
